import { PublicClientApplication } from "@azure/msal-browser";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Modal, ModalBody, Row, Spinner } from "reactstrap";
import { loginActionAzure } from "../../actions/general";
import useMSAL from "../../hooks/useMSAL";
import illustration from "../../resources/SVG/IMG_680x324px_Ilustration.svg";
import { msalSettingsServices } from "../../services";
import "./login.css";

const LoginModal = ({ showAuthModal, isFetching }) => {
  const [isFetchingMSAL, setIsFetchingMSAL] = useState(false);

  const [msalInstance, setMsalInstance] = useState(null);
  const [msalSettings, setMsalSettings] = useState({
    clientId: "",
    tenantId: "",
    redirectUri: "",
  });
  const location = useLocation();
  const history = useHistory();

  const { handleLogin } = useMSAL({
    setIsFetchingMSAL,
    msalInstance,
    clientId: msalSettings.clientId,
    tenantId: msalSettings.tenantId,
  });

  const [xs, setXs] = useState(window ? window.innerWidth <= 575 : false);
  useEffect(() => {
    const onResize = (e) => {
      const windowWidth = e.target.innerWidth;
      if (windowWidth <= 575) {
        setXs(true);
      } else {
        setXs(false);
      }
    };

    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);
  const getMSALSettings = async () => {
    return msalSettingsServices()
      .getMSALSettings()
      .then((res) => {
        if (res && res.data) {
          const setting = {
            clientId: res.data.clientID ?? "",
            tenantId: res.data.tenantID ?? "",
            redirectUri: res.data.redirectUri ?? "",
          };
          return setting;
        }
      })
      .catch(() => {
        return { clientId: "", tenantId: "", redirectUri: "" };
      });
  };

  const signWithAzure = async (credentials) => {
    try {
      await loginActionAzure(
        credentials.username,
        credentials.password,
        history
      );
    } catch (error) {}
  };
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const username = query.get("el");
    const password = query.get("ac");

    if (username && password) {
      signWithAzure({ username, password });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    const initializeMSAL = async () => {
      try {
        const { clientId, tenantId, redirectUri } = await getMSALSettings();
        setMsalSettings({ clientId, tenantId, redirectUri });

        const config = {
          auth: {
            clientId: clientId,
            authority: `https://login.microsoftonline.com/${tenantId}`,
            redirectUri: redirectUri,
            postLogoutRedirectUri: "/",
          },
          cache: {
            cacheLocation: "sessionStorage", // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
          },
        };
        const instance = new PublicClientApplication(config);
        if (!msalInstance) setMsalInstance(instance);
      } catch (error) {
        console.error("Error initializing MSAL", error);
      }
    };

    initializeMSAL();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const azureLoginForm = (
    <div className="card-left">
      <Row className="mr-0" style={{ marginTop: "15%" }}>
        <div
          className=""
          style={{ width: "100%", textAlign: "center" }}
        >
          <Button
            className="login-azure-button"
            type="button"
            size="lg"
            onClick={handleLogin}
            style={{
              backgroundColor: "#0078D4",
              border: "none",
              color: "white",
              fontSize: "16px",
              width: "100%",
              marginBottom: "20px",
            }}
            disabled={isFetching || isFetchingMSAL}
          >
            {isFetching || isFetchingMSAL ? (
              <>
                <Spinner size="sm">Loading...</Spinner>
                <span> Loading</span>
              </>
            ) : (
              "Sign in with SSO"
            )}
          </Button>
        </div>
      </Row>
    </div>
  );

  return (
    <Modal
      isOpen={
        showAuthModal ||
        !(
          sessionStorage.getItem("usernameLFS") &&
          sessionStorage.getItem("tokenAuthLFS")
        )
      }
      className="my-login"
      fade={false}
    >
      <ModalBody>
        <Row style={{ marginLeft: "-16px" }}>
          <div className="hidden-xs col-sm-6 col-md-8">
            <div className="hidden-xs big-background-img  overflow-auto">
              <h3 className="welcome card-left pt-5">Welcome to</h3>

              <h1 className="title card-left">
                Legal & Field Staff <br />
              </h1>

              <div className="illustration-container card-left">
                <img
                  src={illustration}
                  alt="login illustration"
                  className="illustration"
                />
              </div>
              {xs &&
                !(
                  sessionStorage.getItem("usernameLFS") &&
                  sessionStorage.getItem("tokenAuthLFS")
                ) &&
                azureLoginForm}
            </div>
          </div>
          {/* two-factor UI removed from LoginModal for this file */}
          {!xs &&
            !(
              sessionStorage.getItem("usernameLFS") &&
              sessionStorage.getItem("tokenAuthLFS")
            ) && (
              <>
                <div className="col-12 col-sm-6 col-md-4 d-flex justify-content-center align-items-center">
                  <div className="">{azureLoginForm}</div>
                </div>
              </>
            )}
        </Row>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = ({ showAuthModal }) => ({
  showAuthModal,
});

const mapDispatchProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchProps)(LoginModal);
